var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"d-flex flex-column flex-lg-row flex-row-fluid bg-white"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }